webpackJsonp([6],{

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(58),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import firebase from '../../Firebase/FirebaseInit'
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    notifications: Array
  },
  computed: {
    sortedNotifications: function sortedNotifications() {
      return this.notifications.sort(function (a, b) {
        return b.timestamp - a.timestamp;
      });
    }
  },
  methods: {
    readMessages: function readMessages() {
      for (var i = 0; i < this.notifications.length; i++) {
        if (!this.notifications[i].read) {
          console.log(this.notifications[i]);
          this.notifications[i].read = true;
          this.$store.dispatch('readNotification', { user: this.$store.getters.user.id, notification: this.notifications[i].id });
        }
      }
    },
    respond: function respond(notification, accepted) {
      var timestamp = new Date().getTime();

      var message = this.$store.getters.user.name + ' has accepted your follow request!';
      if (!accepted) {
        message = this.$store.getters.user.name + ' has rejected your follow request!';
      }

      var response = {
        message: message,
        senderID: this.$store.getters.user.id,
        senderName: this.$store.getters.user.name,
        receiverID: notification.senderID,
        receiverName: notification.senderName,
        read: false,
        accepted: accepted,
        type: 'ContactResponse',
        timestamp: timestamp
      };

      var sender = {
        contactID: notification.senderID,
        contactName: notification.senderName,
        accepted: true,
        timestamp: timestamp
      };

      var receiver = {
        contactID: notification.receiverID,
        contactName: notification.receiverName,
        accepted: true,
        timestamp: timestamp
      };

      if (accepted) {
        this.$store.dispatch('addContact', { payload: sender, userID: notification.receiverID });
        this.$store.dispatch('addContact', { payload: receiver, userID: notification.senderID });
      } else {
        this.$store.dispatch('deleteContact', { account: notification.senderID, contact: notification.receiverID });
      }

      this.$store.dispatch('sendNotification', response);

      notification.message = 'You have a new contact: ' + notification.senderName;
      notification.accepted = true;
      notification.read = true;
      notification.timestamp = new Date().getTime();
      notification.type = 'ContactSuccess';

      this.$store.dispatch('updateNotification', notification);
    }
  },
  created: function created() {
    console.log(this.$parent);
  }
});

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "chat",
    attrs: {
      "color": "secondary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Notifications")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.sortedNotifications), function(notification) {
    return [_c('v-list-tile', {
      key: notification.id,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s((notification.read) ? notification.message : notification.message.bold())
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s((notification.read) ? new Date(notification.timestamp).toLocaleString() + ' - Seen' : new Date(notification.timestamp).toLocaleString())
      }
    }), _vm._v(" "), _c('v-card-actions', [(notification.type == 'ContactRequest') ? _c('v-btn', {
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.respond(notification, true)
        }
      }
    }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (notification.type == 'ContactRequest') ? _c('v-btn', {
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.respond(notification, false)
        }
      }
    }, [_vm._v("Reject")]) : _vm._e()], 1)], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.74f15482f05fc370bd9e.js